// Protected route dla panelu handlowca - wymaga ROLE_TRADER, w trakcie ładowania profilu pokazuje loader

import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { Loader } from 'components/controls';
import useRoutes from 'routes/useRoutes';

const TRADER_ALLOWED_ROLE = 'ROLE_ADMIN'; //todo zmienić na TRADER

const TraderPanelProtectedRoute = () => {
  const { isProfileLoading, profile } = useRoutes();

  if (isProfileLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
        <Loader />
      </div>
    );
  }

  if (profile?.role !== TRADER_ALLOWED_ROLE) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default TraderPanelProtectedRoute;
